import React, { useState } from "react";

const MyContext = React.createContext();

function MyProvider(props) {
  const [myData, setMyData] = useState([]);

  return (
    <MyContext.Provider value={[myData, setMyData]}>
      {props.children}
    </MyContext.Provider>
  );
}

export { MyContext, MyProvider };
